import axios from "axios";
import { useContext } from "react";
import useSWR from "swr";
import { AuthContext } from "../../../contexts/AuthContext";
import { APIEndpointEnum } from "../../../enums/endpoint";
import { API_URL, INVITE_ACCESS_ENABLED } from "../../../utils/env";

export interface InviteStatusResponse {
  invite_required: boolean;
  allowed: boolean;
  account?: string;
  redeemed_code?: string;
}

const INVITE_DISABLED_STATUS: InviteStatusResponse = {
  invite_required: false,
  allowed: true,
};

export const useInviteStatus = () => {
  const { account } = useContext(AuthContext);

  return useSWR<InviteStatusResponse>(
    INVITE_ACCESS_ENABLED && account
      ? [APIEndpointEnum.INVITE_STATUS, account]
      : undefined,
    async () => {
      const response = await axios.get<InviteStatusResponse>(
        `${API_URL}${APIEndpointEnum.INVITE_STATUS}`,
        { params: { account } }
      );
      return response.data;
    },
    {
      fallbackData: INVITE_ACCESS_ENABLED ? undefined : INVITE_DISABLED_STATUS,
      refreshInterval: INVITE_ACCESS_ENABLED ? 15000 : 0,
      dedupingInterval: 15000,
      shouldRetryOnError: false,
    }
  );
};
